import { packingTemplateIdFormat } from "@redotech/redo-fulfillment-id";
import { WeightSchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import {
  AttributeSchema,
  MeasurementSchema,
} from "@redotech/redo-inventory-common/attributes";
import { ListingsWithStatusSchema } from "@redotech/redo-model/inventory/listing-status";
import { PackingTemplateTypeSchema } from "@redotech/redo-model/inventory/packing-template";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";
import { SupplierProductInput } from "../supplier-products/supplier-product-types";

const ImageSchema = z.object({
  id: z.string(),
  url: z.string(),
  altText: z.string(),
  thumbhash: z.string().nullish(),
  position: z.number(),
});

const PackingTemplateInputSchema_ = z.object({
  id: packingTemplateIdFormat.schema.optional(),
  name: z.string(),
  barcode: z.string().nullable().optional(),
  templateType: PackingTemplateTypeSchema,
  unitsPerBox: z.number().positive().nullable().optional(),
  boxWeight: WeightSchema.nullable().optional(),
  boxLength: MeasurementSchema.nullable().optional(),
  boxWidth: MeasurementSchema.nullable().optional(),
  boxHeight: MeasurementSchema.nullable().optional(),
});

export const PackingTemplateInputSchema: z.ZodType<PackingTemplateInput> =
  PackingTemplateInputSchema_;
export interface PackingTemplateInput extends z.infer<
  typeof PackingTemplateInputSchema_
> {}

export const updateProduct = {
  name: "updateProduct" as const,
  input: z.object({
    productId: productIdFormat.schema,
    title: z.string().optional(),
    description: z.string().optional(),
    vendor: z.string().nullable().optional(),
    tags: z.array(z.string()).optional(),
    sku: z.string().nullable().optional(),
    upc: z.string().nullable().optional(),
    barcodes: z.array(z.string()).optional(),
    price: z.number().nullable().optional(),
    cost: z.number().nullable().optional(),
    currency: z.string().nullable().optional(),
    weight: WeightSchema.nullable().optional(),
    length: MeasurementSchema.nullable().optional(),
    width: MeasurementSchema.nullable().optional(),
    height: MeasurementSchema.nullable().optional(),
    taxCode: z.string().nullable().optional(),
    taxable: z.boolean().nullable().optional(),
    physicalItem: z.boolean().nullable().optional(),
    nonPicked: z.boolean().optional(),
    trackLotFulfillment: z.boolean().optional(),
    originCountry: z.string().nullable().optional(),
    hsCode: z.string().nullable().optional(),
    attributes: z.array(AttributeSchema).optional(),
    images: z.array(ImageSchema).optional(),
    listings: ListingsWithStatusSchema.optional(),
    supplierProducts: z.array(SupplierProductInput).optional(),
    defaultPackingTemplateId: packingTemplateIdFormat.schema
      .nullable()
      .optional(),
    packingTemplates: z.array(PackingTemplateInputSchema).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
